import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import SaveButton from "../../../components/Buttons/SaveButton";
import FileUploadField from "../../../components/Fields/FileUploadField";
import TextboxField from "../../../components/Fields/TextboxField";
import { FormConfig } from "../../../components/Fields/Types";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import SpinnerOverlay from "../../../components/Spinner/SpinnerOverlay";
import { useNotifications } from "../../../contexts/notificationContext";
import { useTranslations } from "../../../contexts/translationContext";
import FileCreateResultModel from "../../../models/FileCreateResultModel";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { DataResult, Result } from "../../../types/Result";

interface IProps extends PopupProps {
    attachmentId: number
}

interface AttachmentReviseModel {
    attachmentId: number
    comment?: string
    fileName?: string
    file?: File
    fileResult?: FileCreateResultModel
}

const ReviseAttachmentPopup: React.FC<IProps> = ({ show, onHide, attachmentId }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const [file, setFile] = useState<File>();
    const [showSpinner, setShowSpinner] = useState(false)
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<AttachmentReviseModel>({
        attachmentId: attachmentId,
    });

    function submit() {
        if (formData && file) {
            setShowSpinner(true)
            DataService
                .createFile(file)
                .then(fileResponse => {
                    handleResult(fileResponse);
                    if (fileResponse.isSuccesful === true && fileResponse.data) {
                        formData.fileResult = fileResponse.data;
                        DataService
                            .post<DataResult<AttachmentReviseModel>>(`api/v1/Attachments/Revise`, formData)
                            .then(response => {
                                setShowSpinner(false)
                                handleResult(response);
                                setServerErrors(response);
                                if (response.isSuccesful === true) {
                                    onHide();
                                }
                            })
                            .catch(e => { handleException(e); setShowSpinner(false); });
                    }
                    else {
                        handleResult(fileResponse)
                        setShowSpinner(false)
                    }
                })
                .catch(e => { handleException(e); setShowSpinner(false); });
        }
    }

    function onFieldChanged(name: string, value: string | File): void {
        if (name === 'fileName' && typeof (value) === 'object') {
            setFile(value);
            formData.fileName = value.name;
        }
        else {
            formData[name] = value;
        }
        setFormData(formData);
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'comment', label: 'Comment', labelSize: 3 },
            { name: 'fileName', label: 'File', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        handleFieldChanged: onFieldChanged,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return <>
        <Popup show={show} onHide={onHide} size={'lg'} title={'Revise Attachment'} >
            <Popup.Body>
                <TextboxField {...getFieldProps('comment')} />
                <FileUploadField {...getFieldProps('fileName')} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Revise' />
            </Popup.Footer>
        </Popup>
        {showSpinner && <SpinnerOverlay />}
    </>
}
export default ReviseAttachmentPopup;